<template>
  <div class="card">
    <div
      class="
        card-header
        d-flex
        justify-content-between
        align-items-center
        pb-50
      "
    >
      <h4 class="card-title">{{ $t("service_statuses.self") }}</h4>
      <div class="d-flex justify-content-center" v-if="!institutionLoading">
        <multiple-select-input
        class="mr-1"
          :model.sync="selectedInstitutions"
          :values="getInstitutions"
          :model="modelInstitution"
          :multiple="false"
        >
        </multiple-select-input>
        <multiple-select-input
          class="mr-1"
          :model.sync="selectedInstitutionsYear"
          :values="institutionsYears"
          :multiple="false"
        >
        </multiple-select-input>
        <multiple-select-input
          class="mr-1"
          :model.sync="selectedInstitutionsMonth"
          :values="institutionsMonth"
          :multiple="false"
          v-if="selectedInstitutionsYear"
          @onSelect="onSelectMonth()"
        >
        </multiple-select-input>
        <button class="btn btn-primary btn-sm" @click="clearData()">
          {{$t('dashboard.clear')}}
        </button>
      </div>
      <div class="d-flex justify-content-center" v-else>
        <loading-box></loading-box>
      </div>
    </div>
    <div
      class="card-body p-0 pb-1 ps ps--active-y ps--scrolling-y"
      v-if="!historyLoading"
    >
      <ul v-if="getHistory.length >= 1" class="list-group list-group-flush">
        <li
          v-for="history in getHistory"
          :key="history.id"
          class="
            list-group-item list-group-item-action
            border-0
            d-flex
            align-items-center
            justify-content-between
          "
        >
          <div class="list-left d-flex">
            <div class="list-icon mr-1">
              <div class="avatar bg-rgba-primary m-0">
                <div class="avatar-content">
                  <i
                    class="font-size-base bx"
                    :class="serviceStatusIcon[history.id - 1]"
                  ></i>
                </div>
              </div>
            </div>
            <div class="list-content">
              <span class="list-title">{{history.name}}</span
              >
            </div>
          </div>
          <span>{{history.count}}</span>
        </li>
      </ul>
      <ul v-else>
        <li
          class="
            list-group-item list-group-item-action
            border-0
            d-flex
            align-items-center
            justify-content-between
          "
        >
          <div class="list-left d-flex">
            <div class="list-content">
              <p>{{ $t("dashboard.data_not_found") }}</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="card-body" v-else>
      <loading-box></loading-box>
    </div>
  </div>
</template>
    
<script>
import MultipleSelectInput from "@/assets/components/inputs/MultipleSelectInput";
import LoadingBox from "@/assets/components/loader/LoadingBox";
import moment from "moment";
import baseModule, {
  ERROR,
  HISTORY_INSTITUTIONS,
  HISTORY_INSTITUTIONS_DATA,
  GET_HISTORY_INSTITUTIONS,
  GET_HISTORY_INSTITUTIONS_DATA,
  GET_INSTITUTIONS_HISTORY_DATA_LOADING,
  MODULE_NAME,
  SUCCESS,
  GET_INSTITUTION_LOADING,
} from "@/core/services/store/dashboard.module";
import store from "@/core/services/store";

const _MODULE_NAME = MODULE_NAME;

export default {
  name: "ServiceHistoryWidget",
  components: {
    MultipleSelectInput,
    LoadingBox,
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }
    registerStoreModule(_MODULE_NAME, baseModule);
  },
  data() {
    return {
      moment: moment,
      selectedInstitutions: null,
      selectedInstitutionsYear: null,
      selectedInstitutionsMonth: null,
      serviceStatusIcon: [
        "bx-download text-success",
        "bxs-user-voice text-primary",
        "bx-car text-primary",
        "bxs-hourglass-top text-warning",
        "bx-stop text-danger",
        "bxs-file-blank text-primary",
        "bx-x-circle text-danger",
        "bx-user-plus text-success",
        "bx-check-circle text-success",
      ],
      institutionsYears: [],
      institutionsMonth: [
        {
          id: 1,
          name: "Ocak",
        },
        {
          id: 2,
          name: "Şubat",
        },
        {
          id: 3,
          name: "Mart",
        },
        {
          id: 4,
          name: "Nisan",
        },
        {
          id: 5,
          name: "Mayıs",
        },
        {
          id: 6,
          name: "Haziran",
        },
        {
          id: 7,
          name: "Temmuz",
        },
        {
          id: 8,
          name: "Ağustos",
        },
        {
          id: 9,
          name: "Eylül",
        },
        {
          id: 10,
          name: "Ekim",
        },
        {
          id: 11,
          name: "Kasım",
        },
        {
          id: 12,
          name: "Aralık",
        },
      ],
      institutionHistory: [],
    };
  },
  computed: {
    error() {
      return store.getters[_MODULE_NAME + "/" + ERROR];
    },
    institutionLoading() {
      return store.getters[_MODULE_NAME + "/" + GET_INSTITUTION_LOADING];
    },
    historyLoading() {
      return store.getters[
        _MODULE_NAME + "/" + GET_INSTITUTIONS_HISTORY_DATA_LOADING
      ];
    },
    success() {
      return store.getters[_MODULE_NAME + "/" + SUCCESS];
    },
    institutions() {
      return store.getters[_MODULE_NAME + "/" + HISTORY_INSTITUTIONS];
    },
    historyInstitutions() {
      return store.getters[_MODULE_NAME + "/" + HISTORY_INSTITUTIONS_DATA];
    },
    getInstitutions() {
      let institutions = this.institutions;
      if (!institutions) return 0;
      return institutions;
    },
    getHistory() {
      this.institutionHistory = [];
      this.institutionHistory = this.historyInstitutions;
      if (!this.institutionHistory) return 0;
      return this.institutionHistory;
    },
    modelInstitution(){
      if(this.getInstitutions.length<=1) return this.getInstitutions[0].id
      return null
    },
  },
  mounted() {
    this.getYears();
    this.filterResults();
    this.filterAllData();
    this.institutionModel
  },
  methods: {
    clearData() {
      this.selectedInstitutions = null;
      this.selectedInstitutionsYear = null;
      this.selectedInstitutionsMonth = null;
      this.institutionHistory = [];
      this.filterAllData();
      this.$emit("historyData",{
        "institution_id":this.selectedInstitutions,
        "month_id":this.selectedInstitutionsMonth,
        "year_id":this.selectedInstitutionsYear
      });
    },
    getYears() {
      this.institutionsYears = [];
      let onePlusYear = moment().year() + 1;
      for (let year = 2022; year < onePlusYear + 1; year++) {
        this.institutionsYears.push({
          id: year,
          name: year,
        });
      }
    },
    
    async filterAllData() {
      await this.$store.dispatch(
        _MODULE_NAME + "/" + GET_HISTORY_INSTITUTIONS_DATA,
        {}
      );
    },
    async filterResults() {
      await this.$store.dispatch(
        _MODULE_NAME + "/" + GET_HISTORY_INSTITUTIONS,
        {}
      );
    },
    async onSelectMonth() {
      let filters = {
        institution_id: this.selectedInstitutions,
        year_id: this.selectedInstitutionsYear,
        month_id: this.selectedInstitutionsMonth,
      };
      await this.$store.dispatch(
        _MODULE_NAME + "/" + GET_HISTORY_INSTITUTIONS_DATA,
        { filters }
      );
      this.getHistory;
      this.$emit("historyData",{
        "institution_id":this.selectedInstitutions,
        "month_id":this.selectedInstitutionsMonth,
        "year_id":this.selectedInstitutionsYear
      });
    },
  },
};
</script>
<style scoped>
.card-body {
  height: 300px;
  overflow: scroll !important;
}
</style>